import { MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material'
import { TBetOperator } from '@pturf-betin/betin-models-lib'
import { OperatorLogo } from 'components/atoms'
import { useBetContext } from 'contexts/BetContext'
import { useTranslation } from 'contexts/TranslationContext'
import { ActionType } from 'models'
import { SyntheticEvent } from 'react'

export const OperatorSelector = () => {
    const { selectedOperator, handleTrackingEvent, setSelectedOperator } =
        useBetContext()
    const translation = useTranslation()

    // TODO: Add onChange={handleChange} when other operators are available
    const handleChange = (e: SelectChangeEvent) => {
        const newOperator = e.target.value as TBetOperator
        setSelectedOperator(newOperator)
        void handleTrackingEvent({
            eventType: 'OPERATOR',
            actionType: newOperator
        })
    }

    const handleClick = (actionType: ActionType, e: SyntheticEvent) => {
        e.stopPropagation()
        void handleTrackingEvent({
            eventType: 'OPERATOR',
            actionType
        })
    }

    const OPERATOR_LOGO_SIZE = 100

    return (
        <Select
            value={selectedOperator}
            // TODO: Use newOperator when available
            renderValue={() => (
                <OperatorLogo
                    operator={selectedOperator}
                    size={OPERATOR_LOGO_SIZE}
                />
            )}
            onChange={handleChange}
            onOpen={(e) => handleClick('OPEN', e)}
            onClose={(e) => handleClick('CLOSE', e)}
            sx={{ height: 55 }}
            MenuProps={{
                MenuListProps: {
                    sx: {
                        p: 0
                    }
                }
            }}
        >
            {['GENYBET', 'PMU'].map((operator) => (
                <MenuItem
                    key={`operator-${operator}`}
                    value={operator}
                    sx={{ justifyContent: 'center' }}
                >
                    <OperatorLogo
                        operator={operator as TBetOperator}
                        size={OPERATOR_LOGO_SIZE}
                    />
                </MenuItem>
            ))}
            {(['PMU.fr'] as TBetOperator[]).map((operator, index) => (
                <MenuItem
                    value={'PMU.fr'}
                    sx={{
                        justifyContent: 'center',
                        filter: 'grayscale(1)',
                        opacity: 0.4,
                        flexDirection: 'column',
                        pb: 0
                    }}
                    key={`item-${operator}`}
                >
                    <OperatorLogo
                        operator={operator}
                        size={OPERATOR_LOGO_SIZE}
                    />
                    <Typography
                        variant="text-12-regular"
                        sx={{ mt: index > 0 ? -0.5 : -1, mb: 1, fontSize: 11 }}
                    >
                        {translation.unavailable}
                    </Typography>
                </MenuItem>
            ))}
        </Select>
    )
}
